import AuthContactPanel from 'components/common/AuthContactPanel';
import React from 'react';

const CourseLandingRightPanel = () => {
  return (
    <>
      <AuthContactPanel />
    </>
  );
};

export default CourseLandingRightPanel;
